import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Menu,
  Text,
  TextInput,
} from "@mantine/core";
import useStyles from "./style";
import { FaPlus } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { LuArrowDownUp, LuDownload } from "react-icons/lu";
import { useEffect, useRef, useState } from "react";
import PipelinesTable from "./PipelinesTable";
import { ReportIconSvg } from "../Svgs/ReportIconSvg";
import AddProspectDrawer from "../AddProspectDrawer";
import { useDisclosure } from "@mantine/hooks";
import {
  deleteSkypointProspect,
  getAllSkypointProspects,
  getAllSkypointProspectsStatus,
  getExportSkypointProspects,
} from "../../services/skypointProspect";
import { useSelector } from "react-redux";
import useDebounce from "../../utils/useDebounce";
import swal from "sweetalert";
import ProspectStatusModal from "../ProspectStatausModal";
import { isStaff } from "../../http";
import { CSVLink } from "react-csv";
import moment from "moment";

const ProspectPipeline = ({
  activeTab,
  activeFilter,
  setActiveFilter,
  currentPage,
  setCurrentPage,
  sortBy,
  setSortBy,
  searchQuery,
  setSearchQuery,
  // filters,
  // setFilters,
}) => {
  const { classes, cx } = useStyles();
  const debouncedSearch = useDebounce(searchQuery, 2000);
  const { profile } = useSelector((state) => state?.profile);

  const {
    skypointProspects,
    skypointProspectsCount,
    skypointProspectsLoading,
    skypointProspectsTotalCount,
    skypointProspectsFiltersCount,
    skypointProspectsStatus,
  } = useSelector((state) => state?.skypointProspects);
  const [mode, setMode] = useState("add");
  const [selectedProspect, setSelectedProspect] = useState(null);
  const [exportData, setExportData] = useState([]);
  const [exporting, setExporting] = useState(false);
  const csvRef = useRef(null);

  const csvHeaders = [
    { label: "Status", key: "status" },
    { label: "Provider Name", key: "providerName" },
    { label: "Contact Name", key: "contactName" },
    { label: "Phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "State", key: "state" },
    { label: "Created Date", key: "createdAt" },
    { label: "Last Contact Date", key: "date" },
    { label: "Amount", key: "amount" },
  ];

  const handleExport = async () => {
    setExporting(true);
    const prospects = await getExportSkypointProspects(
      isClosedTab ? "694139dbf2f43007ea71e179" : activeFilter !== "All" ? activeFilter : undefined,
      sortBy,
      debouncedSearch
    );
    setExporting(false);
    if (!prospects?.length) return;
    const rows = prospects.map((item) => ({
      status: item?.ProspectStatus?.ProspectStatus || "-",
      providerName: `${item?.firstName || ""} ${item?.lastName || ""}`.trim() || "-",
      contactName: `${item?.contactFirstName || ""} ${item?.contactLastName || ""}`.trim() || "-",
      phone: item?.phone || "-",
      email: item?.email || "-",
      state: item?.state || "-",
      createdAt: item?.createdAt ? moment(item.createdAt).format("DD/MM/YYYY") : "-",
      date: item?.date ? moment(item.date).format("DD/MM/YYYY") : "-",
      amount: item?.amount || "0",
    }));
    setExportData(rows);
    setTimeout(() => csvRef.current?.link?.click(), 100);
  };
  const isClosedTab = activeTab === "closed";
  const [opened, { open, close }] = useDisclosure(false);

  const [
    addProspectOpened,
    { open: addProspectOpen, close: addProspectClosed },
  ] = useDisclosure(false);

  const handleModalClose = async () => {
    close();
    await getAllSkypointProspectsStatus();
  };

  const callGetProspectWithFiltersCount = () => {
    const filtersCountArry = skypointProspectsStatus.map(({ id }) => id);
    getAllSkypointProspects(
      currentPage,
      isClosedTab
        ? "694139dbf2f43007ea71e179"
        : activeFilter !== "All"
        ? activeFilter
        : null,
      filtersCountArry,
      sortBy,
      debouncedSearch
    );
  };

  useEffect(() => {
    callGetProspectWithFiltersCount();
  }, [
    activeFilter,
    currentPage,
    sortBy,
    debouncedSearch,
    activeTab,
    skypointProspectsStatus,
  ]);

  const handleNewProspectClick = () => {
    setSelectedProspect(null);
    setMode("add");
    addProspectOpen();
  };

  const handleEditProspectClick = (data) => {
    setSelectedProspect(data);
    setMode("edit");
    addProspectOpen();
  };

  const handleViewProspectClick = (data) => {
    setSelectedProspect(data);
    setMode("view");
    addProspectOpen();
  };

  const handleDeleteProspectClick = async (data) => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) {
      deleteSkypointProspect(data?._id, callGetProspectWithFiltersCount);
    }
  };

  const handleDrawerClose = () => {
    setSelectedProspect(null);
    setMode("add");
    addProspectClosed();
  };

  return (
    <>
      {skypointProspects?.length > 0 ||
      skypointProspectsTotalCount > 0 ||
      skypointProspectsLoading ? (
        <Box className={classes.prospectPipelineContent}>
          <Flex className={classes.hdngAndBtn}>
            <p>{isClosedTab ? "Closed Prospects" : "All Prospects"}</p>
            <Button
              leftIcon={<FaPlus size={20} color="#262626" />}
              className={classes.newProspectBtn}
              onClick={handleNewProspectClick}
            >
              New Prospect
            </Button>
          </Flex>
          <Flex className={classes.filterRow}>
            <TextInput
              icon={<CiSearch size={20} color="#737373" />}
              className={classes.searchInput}
              placeholder="Search provider name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Menu
              className={classes.sortByMenu}
              classNames={{
                item: classes.sortByItem,
                dropdown: classes.sortByDropdown,
              }}
            >
              <Menu.Target>
                <Flex>
                  <LuArrowDownUp size={18} />
                  Sort By
                </Flex>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item onClick={() => setSortBy("newest")}>
                  Newest
                </Menu.Item>
                <Menu.Item onClick={() => setSortBy("oldest")}>
                  Oldest
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
            <Button
              className={classes.exportBtn}
              leftIcon={<LuDownload size={16} />}
              onClick={handleExport}
              loading={exporting}
            >
              Export
            </Button>
            <CSVLink
              ref={csvRef}
              data={exportData}
              headers={csvHeaders}
              filename={`prospects-${moment().format("YYYY-MM-DD")}.csv`}
              style={{ display: "none" }}
            />
          </Flex>
          {!isClosedTab && (
            <Flex className={classes.filtersTagRow}>
              <Button
                key={"All"}
                className={cx(
                  classes.filterTag,
                  activeFilter === "All" ? classes.activeFilterTag : ""
                )}
                onClick={() => setActiveFilter("All")}
              >
                <p className="filterName">All</p>
                <Box className="countBox">{skypointProspectsTotalCount}</Box>
              </Button>
              {skypointProspectsStatus?.map((status) => (
                <Button
                  key={status?.id}
                  className={cx(
                    classes.filterTag,
                    activeFilter === status?.id ? classes.activeFilterTag : ""
                  )}
                  onClick={() => {
                    setCurrentPage(1);
                    setActiveFilter(status?.id);
                  }}
                >
                  <p className="filterName">{status?.ProspectStatus}</p>
                  <Box className="countBox">
                    {skypointProspectsFiltersCount[status?.id] ?? 0}
                  </Box>
                </Button>
              ))}
              {!isStaff(profile?.user?.role) && (
                <ActionIcon size="xs" variant="transparent">
                  <FaPlus size={18} color="#262626" onClick={open} />
                </ActionIcon>
              )}
              <ProspectStatusModal opened={opened} onClose={handleModalClose} />
            </Flex>
          )}
          <PipelinesTable
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onEditClick={handleEditProspectClick}
            onViewClick={handleViewProspectClick}
            onDeleteClick={handleDeleteProspectClick}
            callGetProspectWithFiltersCount={callGetProspectWithFiltersCount}
          />
        </Box>
      ) : (
        <Box className={classes.emptyReportsBox}>
          <Flex align="center" justify="center" className={classes.iconBox}>
            <ReportIconSvg color="#262626" />
          </Flex>
          <Text fz={20} fw={600} ff="Inter" color="#171717">
            Manage your pipeline, sales, and solicitor relationships
          </Text>
          <Text mt={10} fz={16} fw={400} ff="Inter" color="#737373">
            No data available. Kindly add a prospect to get started
          </Text>
          <Button
            mt={44}
            className={classes.newProspectBtn}
            onClick={handleNewProspectClick}
          >
            Add Prospect
          </Button>
        </Box>
      )}
      <AddProspectDrawer
        drawerOpen={addProspectOpened}
        drawerClose={handleDrawerClose}
        callGetProspectWithFiltersCount={callGetProspectWithFiltersCount}
        mode={mode}
        data={selectedProspect}
      />
    </>
  );
};

export default ProspectPipeline;
